import { queryOptions, useQuery } from '@tanstack/react-query'
import { QueryConfig } from '@/utils/reactQuery'
import apiClient from '@/utils/api'
import { Location } from '@/features/location/types/locationModels'

const getLocation = async (locationId: string): Promise<Location> => {
  const { data } = await apiClient.get(`/locations/${locationId}`)
  return data
}

const getLocationOptions = (locationId: string) => {
  return queryOptions({
    queryKey: ['location', locationId],
    queryFn: () => getLocation(locationId),
  })
}

type UseLocationProps = {
  id: string
  queryConfig?: QueryConfig<typeof getLocationOptions>
}

const useLocation = ({ id, queryConfig }: UseLocationProps) => {
  return useQuery({
    ...getLocationOptions(id),
    ...queryConfig,
  })
}

export { getLocation, getLocationOptions, useLocation }
